<template lang="pug">
.empty-state
  .empty-state-icon
    i(:class="icon")
  p.empty-state-title {{ title }}
  p.empty-state-message(v-if="message") {{ message }}
  .empty-state-action(v-if="$slots.default")
    slot
</template>

<script>
/**
 * Estado vacío para tablas y listados.
 *
 * Sin esto, una tabla sin resultados quedaba como un encabezado y un
 * paginador flotando sobre el vacío, que se lee como "algo se rompió"
 * en lugar de "todavía no hay datos".
 *
 * Uso dentro de un DataTable:
 *   template(#empty)
 *     EmptyState(icon="pi pi-users" title="Todavía no hay clientes")
 *       Button(label="Nuevo cliente" @click="...")
 */
export default {
  name: 'EmptyState',
  props: {
    /** Clase del ícono de PrimeIcons, ej: 'pi pi-inbox' */
    icon: {
      type: String,
      default: 'pi pi-inbox',
    },
    /** Qué falta. Preferir afirmativo: "Todavía no hay clientes" */
    title: {
      type: String,
      required: true,
    },
    /** Opcional: cómo resolverlo */
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem 1.5rem;
  gap: 0.25rem;
}

.empty-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 0.75rem;
  border-radius: var(--escality-radius-full);
  background: var(--escality-gray-100);
  color: var(--escality-gray-400);
  font-size: 1.5rem;
}

.empty-state-title {
  margin: 0;
  font-family: var(--escality-heading-family);
  font-weight: var(--escality-font-weight-semibold);
  font-size: var(--escality-text-md);
  color: var(--escality-gray-700);
}

.empty-state-message {
  margin: 0;
  max-width: 42ch;
  font-size: var(--escality-text-base);
  color: var(--escality-gray-500);
}

.empty-state-action {
  margin-top: 1rem;
}
</style>
